module.exports = __webpack_public_path__ + "media/images/front/review_star_04-646e9101a7d5a98923eb8f01cb0c6a0c.png";